import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_FoodAllergiesForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_FoodAllergiesForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Food Allegies Form</h3></p>
                
                <p className='w-750'>
                    <span className='eleHeader'>Please list any food allergies or intolerances.</span>
                    <textarea id='txtFood' name='txtFood' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Please check one of the following:</strong>
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkFood' id='chkFood' className='add-only' value='Client' /> Client DOES NOT have a food allergy or dietary restriction. He or she MAY participate in snack and/or lite meals.
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkFood1' id='chkFood1' className='add-only' value='Aggressive' /> Client DOES have a food allergy or dietary restriction. He or she MAY participate in snack and/or lite meals, but MAY NOT eat the items listed below.
                </p>
                <p className='w-750'>
                    <input type='checkbox' name='chkFood2' id='chkFood2' className='add-only' value='Allergy' /> Client DOES have a food allergy or dietary restriction. He or she MAY NOT participate in any snack and/or lite meals.
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Allergy</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Reaction</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Treatment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAllergy1' id='txtAllergy1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtReaction1' id='txtReaction1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtTreatment1' id='txtTreatment1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAllergy2' id='txtAllergy2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtReaction2' id='txtReaction2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtTreatment2' id='txtTreatment2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAllergy3' id='txtAllergy3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtReaction3' id='txtReaction3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtTreatment3' id='txtTreatment3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAllergy4' id='txtAllergy4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtReaction4' id='txtReaction4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtTreatment4' id='txtTreatment4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAllergy5' id='txtAllergy5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtReaction5' id='txtReaction5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtTreatment5' id='txtTreatment5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I release Lilly Pad Home, LLC from any liability associated with illness that could occur from the consumption of snacks of snacks and lite meals that I may receive while at the office.
                </p>

                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Client Signature:</td>
                        <td className='small w-300'>Signature of Parent:</td>
                        <td className='small w-150'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











